import {currentCartIsEmpty} from './currentCartIsEmpty';

export const currentCartIsNotEmpty = () => !currentCartIsEmpty();

export default currentCartIsNotEmpty;
